module.exports = __webpack_public_path__ + "static/media/02_tn.2f7f3c83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/02_tn.jpg
// module id = 491
// module chunks = 0